import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Also send Authorization header as fallback for cookies not set (some browsers/preview)
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("lim_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Completion gate: backend answers 409 TIME_REQUIRED when a task is marked
// complete with no tracked time. A registered handler asks for hours, logs
// them, and the original request is retried transparently.
let timeRequiredHandler = null;
export const registerTimeRequiredHandler = (fn) => { timeRequiredHandler = fn; };

api.interceptors.response.use(undefined, async (error) => {
  const d = error?.response?.data?.detail;
  const cfg = error?.config;
  if (error?.response?.status === 409 && d && d.code === "TIME_REQUIRED" && cfg && timeRequiredHandler) {
    cfg._timeTries = (cfg._timeTries || 0) + 1;
    if (cfg._timeTries <= 10 && (await timeRequiredHandler(d))) return api(cfg);
  }
  return Promise.reject(error);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
